module.exports = __webpack_public_path__ + "img/country2.cfdbd21b.jpg";